// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"3542fb7a","267":"b25d6198","453":"68693753","526":"258f149d","588":"43acd5b3","590":"8dcdf53c","642":"ebc0beff","719":"96c8cd3b"}[chunkId] + ".chunk.js";
};